import { CHANNELS } from "@/mocks/gua";

const STATS = [
  { num: "96", label: "今日新增" },
  { num: "2.4万", label: "累计收录" },
  { num: "32", label: "正在围观" },
];

export default function Hero() {
  return (
    <section id="top" className="w-full bg-[#faf6ef]">
      <div className="mx-auto w-full px-4 pb-6 pt-10 md:px-6 md:pb-10 md:pt-14">
        <div className="flex flex-col items-start gap-8 lg:flex-row lg:items-end lg:justify-between">
          {/* 主标题（上疏） */}
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold text-orange-700">
              <i className="ri-flashlight-fill" /> 全网吃瓜情报站
            </span>
            <h1 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-stone-900 md:text-5xl">
              新瓜速递 · 热门事件
              <br className="hidden sm:block" />
              <span className="text-orange-600">前排围观现场</span>
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-stone-600 md:text-base">
              一手现场图文直击，第一时间满足你的好奇心。这里有持续滚动的新瓜，也有按题材归好的合集入口，
              想看热闹，来这里蹲个前排。
            </p>
          </div>

          {/* 实时统计 */}
          <div className="flex w-full gap-3 sm:w-auto lg:shrink-0">
            {STATS.map((s) => (
              <div
                key={s.label}
                className="flex min-w-[88px] flex-1 flex-col rounded-lg border border-stone-200/80 bg-white px-4 py-3 sm:flex-none"
              >
                <span className="text-xl font-extrabold text-orange-600">{s.num}</span>
                <span className="mt-0.5 text-xs text-stone-500">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* 频道快速入口 */}
        <div className="mt-8 border-t border-dashed border-stone-300/70 pt-5 md:mt-10">
          <p className="text-xs font-semibold uppercase tracking-wider text-stone-400">热门频道 · 直达入口</p>
          <div className="mt-3 flex flex-wrap gap-2 md:gap-2.5">
            {CHANNELS.map((c, i) => (
              <a
                key={c}
                href="#zone"
                className="group flex items-center gap-2 whitespace-nowrap rounded-full border border-stone-200 bg-white px-4 py-2 text-sm text-stone-700 transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-700"
              >
                <span
                  className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold text-white ${
                    i % 3 === 0 ? "bg-orange-500" : i % 3 === 1 ? "bg-rose-400" : "bg-amber-500"
                  }`}
                >
                  {c.slice(0, 1)}
                </span>
                {c}
                <i className="ri-arrow-right-line text-xs text-stone-300 transition group-hover:translate-x-0.5 group-hover:text-orange-500" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}